function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#33AFFF",
  d: "M22 7a2 2 0 00-2-2h-5a2 2 0 00-2 2v14l1.414-1.414A2 2 0 0115.828 19H20a2 2 0 002-2V7z",
  opacity: 0.6
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#33AFFF",
  d: "M3 7a2 2 0 012-2h5a2 2 0 012 2v14l-1.414-1.414A2 2 0 009.172 19H5a2 2 0 01-2-2V7z"
});

function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZmlsbD0iIzMzQUZGRiIgZD0iTTIyIDdhMiAyIDAgMDAtMi0yaC01YTIgMiAwIDAwLTIgMnYxNGwxLjQxNC0xLjQxNEEyIDIgMCAwMTE1LjgyOCAxOUgyMGEyIDIgMCAwMDItMlY3eiIgb3BhY2l0eT0iLjYiLz4KICA8cGF0aCBmaWxsPSIjMzNBRkZGIiBkPSJNMyA3YTIgMiAwIDAxMi0yaDVhMiAyIDAgMDEyIDJ2MTRsLTEuNDE0LTEuNDE0QTIgMiAwIDAwOS4xNzIgMTlINWEyIDIgMCAwMS0yLTJWN3oiLz4KPC9zdmc+Cg==";
export { SvgDocs as ReactComponent };